export default __webpack_public_path__ + "static/media/69.df0987fe.jpg";